<template>
  <div class="feedback-type">
    <div class="title">{{data.courtesy}}</div>
    <div class="type-list">
      <div
        v-for="(type, index) in data.content"
        :key="`type-item-${index}`"
        @click="selectFeedbackTypes(type.name)"
      >
        {{type.name}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'feedback-type',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    selectFeedbackTypes(type) {
      this.$emit('selectFeedbackTypes', type)
    }
  }
}
</script>
